import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useModules(locationId?: string) {
  const qs = locationId ? `?locationId=${locationId}` : '';
  return useQuery({
    queryKey: ['modules', locationId ?? null],
    queryFn: () =>
      api.get<{
        data: {
          moduleName: string;
          isActive: boolean;
          superAdminEnabled: boolean;
          activatedAt: string | null;
          deactivatedAt: string | null;
        }[];
      }>(`/modules${qs}`),
  });
}

export function useToggleModule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      moduleName,
      isActive,
      locationId,
    }: {
      moduleName: string;
      isActive: boolean;
      locationId?: string;
    }) => api.put(`/modules/${moduleName}/toggle`, { isActive, locationId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['modules'] });
    },
  });
}
